<template>
    <main class="activate-account">
        <div class="page-header">
            <h1 class="page-header__title">Aktywacja konta</h1>
        </div>
        <form class="code">
            <div class="code__desc">
                <p>Aby aktywować konto, wpisz poniżej kod przesłany na Twój adres e-mail.</p>
            </div>
            <form class="code__form" @submit="handleSubmit">
                <div class="form__success" v-if="success">{{ success }}</div>
                <div class="code__section">
                    <div class="form__row code__row">
                        <img src="@/assets/svg/lock.svg" alt/>
                        <input
                            type="text"
                            class="code__input"
                            @blur="checkCode"
                            v-model="code"
                            placeholder="KOD"
                        />
                        <div v-if="error" class="form__row-error form__row-error--icon">{{ error }}</div>
                    </div>
                    <div class="form__row code__row">
                        <a @click="handleSubmit" :class="submitBtnClass">Aktywuj konto</a>
                    </div>
                </div>
            </form>
            <div class="code__desc">
                Jeśli wiadomość nie dotarła prosimy o kontakt z nami.
                <br/>
                <router-link to="/kontakt" class="login-actions__link">Kontakt</router-link>
            </div>
        </form>
    </main>
</template>

<script>
import axios from "axios";

export default {
    name: "ActivateAccount",
    data() {
        return {
            submitBtnClass: "btn",
            success: '',
            error: '',
            code: ''
        };
    },
    methods: {
        checkCode() {
            this.error = "";
            !this.code ? (this.error = "Kod autoryzacyjny jest wymagany") : null;
        },
        handleSubmit(e) {
            e.preventDefault();

            this.checkCode();

            if (this.code && !this.error) {
                this.submitBtnClass = "brn spinner spinner--running";
                axios({
                    method: "post",
                    url: `${process.env.VUE_APP_API_URL}/register/activate`,
                    data: {
                        doctorId: this.$route.params.doctorId,
                        code: this.code
                    }
                })
                    .then(() => {
                        this.submitBtnClass = "brn spinner spinner--complete";
                        this.success = "Konto zostało aktywowane";
                        setTimeout(() => this.$router.push("/zaloguj-sie"), 3000);
                    })
                    .catch((err) => {
                        this.error = err.response.data.message;
                        this.submitBtnClass = "btn";
                    });
            }
        }
    }
};
</script>

<style lang="scss">
.code {
    width: 95%;
    max-width: 700px;
    margin: 30px auto;

    &-actions {
        text-align: center;

        .btn {
            margin-top: 15px;
        }
    }

    &__desc {
        text-align: center;
        font-size: 14px;

        h3 {
            margin-bottom: 0;
        }

        p {
            margin-top: 0;
        }
    }

    &__section {
        max-width: 300px;
        margin: auto;
    }

    &__row {
        margin: 30px 0;
        position: relative;
        justify-content: center;

        img {
            position: absolute;
            left: 13px;
            top: 8px;
        }
    }

    &__input {
        padding: 0 0 0 40px !important;
    }
}
</style>
